import script from "./AButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./AButton.vue?vue&type=script&setup=true&lang=ts"

import "./AButton.vue?vue&type=style&index=0&id=6ee86d1a&scoped=true&lang=scss"

import exportComponent from "/Users/jansavli/Documents/Socutno Zobozdravstvo/socutno-webpage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ee86d1a"]])

export default __exports__